import React, { useState, useEffect } from 'react';
import { INDEX_URL, GOOGLE_MAPS_KEY, icons, FLAVOR } from "../../helpers/constants";
import { fixDate } from "../../helpers/helperFunctions";
import SegmentedControl from '../SegmentedControl/SegmentedControl';
import TextField from "@mui/material/TextField";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs'; // Import dayjs
import 'dayjs/locale/sv';
import { MapTogglesProvider, useMapToggles } from '../Map/ToggleContext'; // Adjust the path as necessary
import { useNavigate } from 'react-router-dom';
import * as request from "../../services/FetchService";
import { useTranslation } from "react-i18next";


const MessageRow = ({ message, openMessage, sharedMessage, index, onClick }) => {
    const { t } = useTranslation();

    const getBgColor = () => {
        if((message.type === "message" || message.type === "info" || message.type === "standard") && openMessage === message.messageid){
            return "bg-primary transition-fast"
        }else if(sharedMessage === message){
            return "bg-primary transition-fast"
        }else if(index % 2){
            return "bg-white transition-fast"
        }else{
            return "bg-light-grey transition-fast"
        }
    }

    const messageContent = () => (
        <div className={`d-flex p-3 cursor-pointer align-items-center transition-fast ${getBgColor()}`} onClick={() => onClick(message)}>          
            <div className="position-relative">
                <div className={`eventImgBg me-3 ${openMessage === message.messageid ? "bg-white" : "bg-primary"}`}>
                    <img src={icons.envelope_gradient} alt="" className={`size_20 eventImg transition-fast ${openMessage !== message.messageid ? "white-icon" : ""}`}/>
                </div>
                {message.isread === 0 &&
                    <span className="position-absolute dot bg-offline top-0 end-0 me-3"/>
                }
            </div>
            <div className="d-flex flex-column pe-5 me-5 w-100">
                <h4 className={`${openMessage === message.messageid ? "white" : "primary"} w-100 fast text-truncate primary`}>{message.title}</h4>
                <p className={`${openMessage === message.messageid ? "white" : "primary"} fast`}>{fixDate(message.creationdate, true)}</p>
            </div>
        </div>   
    )

    const ticketContent = () => (
        <div className={`d-flex p-3 cursor-pointer align-items-center ${getBgColor()}`} onClick={() => onClick(message)}>          
            <div className="position-relative">
                <div className={`eventImgBg me-3 ${openMessage === message.ticket_id ? "bg-white" : "bg-primary"}`}>
                    <img src={icons.questionmark} alt="" className={`size_20 eventImg transition-fast ${openMessage !== message.ticket_id ? "white-icon" : ""}`}/>
                </div>
                {message.isread === 0 &&
                    <span className="position-absolute dot bg-offline top-0 end-0 me-3"/>
                }
            </div>
            <div className="d-flex flex-column pe-5 me-5 w-100">
                <h4 className={`${openMessage === message.ticket_id ? "white" : "primary"} w-100 fast text-truncate primary`}>{message.title}</h4>
                <p className={`${openMessage === message.ticket_id ? "white" : "primary"} fast`}>{message.content}</p>
            </div>
        </div>   
    )

    const infoContent = () => (
        <div className={`d-flex p-3 cursor-pointer align-items-center ${getBgColor()}`} onClick={() => onClick(message)}>          
            <div className="position-relative">
                <div className={`eventImgBg me-3 ${openMessage === message.messageid ? "bg-white" : "bg-primary"}`}>
                    <img src={icons.info_icon} alt="" className={`size_20 eventImg transition-fast ${openMessage !== message.messageid ? "white-icon" : ""}`}/>
                </div>
                {message.isread === 0 &&
                    <span className="position-absolute dot bg-offline top-0 end-0 me-3"/>
                }
            </div>
            <div className="d-flex flex-column pe-5 me-5 w-100">
                <h4 className={`${openMessage === message.messageid ? "white" : "primary"} w-100 fast text-truncate primary`}>{message.title}</h4>
                <p className={`${openMessage === message.messageid ? "white" : "primary"} fast`}>{fixDate(message.creationdate, true)}</p>
            </div>
        </div>   
    )

    const shareContent = () => (
        <div className={`d-flex p-3 cursor-pointer align-items-center ${getBgColor()}`} onClick={() => onClick(message)}>          
            <div className="position-relative">
                <div className={`rounded-circle message-img-bg me-3 ${sharedMessage === message ? "bg-white" : "bg-primary"}`}>
                    <img src={icons.sharing} alt="" className={`size_20 ${sharedMessage !== message ? "white-icon" : ""}`}/>
                </div>
                <span className="position-absolute dot bg-offline top-0 end-0 me-3"/>
            </div>
            <div className="d-flex flex-column overflow-hidden">
                <h4 className="text-truncate">{message ? message?.title : t("inapp.share_device_request")}</h4>
                <p className="text-truncate">{message ? message?.content : t("inapp.share_device_request_sub", {from: message.sharedfrom})}</p>
            </div>
        </div>
    )

    const renderContent = () => {
        switch(message.type){
            case "standard":
                return messageContent()
            case "message":
                return messageContent()
            case "tickets":
            return ticketContent()
            case "alerts":
                if(message?.subtype === "shared_device_invitation"){
                    return shareContent()
                }else{
                    return null
                }
            default: return null;
        }
    }

    return(
        <>
            {renderContent()}
        </>
    )
}

export default MessageRow;